import { useEffect } from 'react';
import { Dialog } from '@mui/material';
import authService from '#services/auth';
import { ConnectivityDialogBody } from '../shared/ConnectivityDialogBody';

// If there are multiple windows open in web (for example there's at least one
// affirmation open), and disconnection happens in some window, when we reload
// that window the authentication state in the shared worker
// packages/client/src/services/auth/auth-worker.ts will remain as if the window
// is still authenticated, but we want to force the user to login again.
const handleBeforeUnload = () => {
  authService.logout();
};

export const DisconnectedDialogComponent = ({ open }: { open: boolean }) => {
  useEffect(() => {
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <Dialog open={open}>
      <ConnectivityDialogBody
        variant="disconnected"
        closeButtonText="Reload"
        onClose={() => {
          window.addEventListener('beforeunload', handleBeforeUnload);
          location.reload();
        }}
      />
    </Dialog>
  );
};
